export default __webpack_public_path__ + "static/media/nodes-icon.65fd51b8.svg";